import { NRLogger as o } from "./contact-channels45.js";
import { attempt as n } from "./contact-channels54.js";
import { initialize as c, waitTillAvailable as d, isFeatureEnabled as t } from "@vp/ab-reader";
const g = async (e, r) => {
  try {
    c();
    const a = await d(2e3);
    if (!a)
      throw o.error("Could not run experiment because ab-reader is not available", {
        abReaderAvailable: a,
        message: "Ab-reader did not become available within the timeout period"
      }), new Error("Ab-reader is not available");
    if (t("help_center_emergency_from_statsig"))
      return {
        enabled: !0,
        code: 200,
        location: "helpcenter",
        message: "Our Services are currently unavailable due to an emergency.",
        config: {
          c2cDisabled: t("hc-phone-disabled"),
          emailDisabled: t("hc-email-disabled"),
          phoneDisabled: t("hc-phone-disabled"),
          chatDisabled: t("hc-chat-disabled")
        },
        Key: `${e}.${r}`
      };
  } catch (a) {
    o.error("Contact Channels: Emergency Feature Gate Check", {
      message: a instanceof Error ? a.message : String(a),
      locale: r,
      tenant: e
    });
  }
  const { data: s, error: i } = await n(
    fetch(
      `https://care-hub.care.vpsvc.com/${e == null ? void 0 : e.toLowerCase()}/${r == null ? void 0 : r.toLowerCase()}/helpcenter/banner/status`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    )
  );
  if (i)
    throw o.error("Contact Channels: Emergency Check", {
      ...i,
      locale: r,
      tenant: e
    }), i;
  if (!s.ok)
    throw o.error("Contact Channels: Emergency Check", {
      status: s.status,
      message: "Failed to fetch EmergencyData"
    }), new Error(`HTTP error! Status: ${s.status}`);
  return s.json();
};
export {
  g as getEmergencyData
};
//# sourceMappingURL=contact-channels41.js.map
